import React, { useState } from 'react';
import { acceptTerms } from '../api';

const s = {
    overlay: {
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 9999, backdropFilter: 'blur(4px)',
    },
    card: {
        background: '#fff', borderRadius: 16, padding: '40px 36px',
        maxWidth: 440, width: '90%', textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    },
    title: {
        fontSize: 22, fontWeight: 800, color: '#1a1d23',
        marginBottom: 8, marginTop: 16,
    },
    text: {
        fontSize: 14, color: '#6b7280', lineHeight: 1.6,
        marginBottom: 24,
    },
    link: {
        display: 'inline-block', color: '#6366f1', fontWeight: 600,
        fontSize: 14, textDecoration: 'none', marginBottom: 24,
    },
    checkRow: {
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        gap: 8, marginBottom: 24, cursor: 'pointer',
    },
    checkbox: {
        width: 18, height: 18, accentColor: '#6366f1', cursor: 'pointer',
    },
    checkLabel: {
        fontSize: 13, color: '#374151', userSelect: 'none', cursor: 'pointer',
    },
    btn: {
        width: '100%', padding: '13px 0', border: 'none', borderRadius: 10,
        fontWeight: 700, fontSize: 15, cursor: 'pointer',
        background: '#6366f1', color: '#fff', transition: 'opacity .2s',
    },
};

export default function TermsAcceptancePopup({ onAccepted }) {
    const [checked, setChecked] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleAccept = async () => {
        setLoading(true);
        try {
            const res = await acceptTerms();
            // Update localStorage
            const client = JSON.parse(localStorage.getItem('client') || '{}');
            client.terms_accepted_at = res.data.terms_accepted_at;
            localStorage.setItem('client', JSON.stringify(client));
            onAccepted();
        } catch (err) {
            alert('Failed to accept terms. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={s.overlay}>
            <div style={s.card}>
                <img src="/logo.svg" alt="OrbitGrowth" style={{ height: 48, borderRadius: 10 }} />
                <div style={s.title}>Terms of Service</div>
                <div style={s.text}>
                    Please read and accept our Terms of Service to continue using OrbitGrowth.
                </div>
                <a href="/terms" target="_blank" rel="noopener noreferrer" style={s.link}>
                    Read Terms of Service &rarr;
                </a>
                <div style={s.checkRow} onClick={() => setChecked(!checked)}>
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={() => setChecked(!checked)}
                        style={s.checkbox}
                    />
                    <span style={s.checkLabel}>I have read and accept the Terms of Service</span>
                </div>
                <button
                    style={{ ...s.btn, opacity: (!checked || loading) ? 0.5 : 1 }}
                    disabled={!checked || loading}
                    onClick={handleAccept}
                >
                    {loading ? 'Please wait...' : 'Continue'}
                </button>
            </div>
        </div>
    );
}
